<style type="text/css">
.leftSideMEnu {
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #3f4254;
}
</style>
<template>
  <div>
    <section class="pa-6">
      <v-row no-gutters class="pb-3">
        <v-col cols="12">
          <v-row>
            <v-col v-for="(section, index) in TopMenuList" :key="index" cols="12" sm="auto" class="mx-auto">
              <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page" :is__gmr_page="is__gmr_page"
                :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="section"
                type_menu="Initial_Menu" @to_close_MenuDialog="to_close_MenuDialog" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <section class="pt-4">
        <v-row no-gutters>
          <v-col cols="12">
            <v-row justify="center">
              <v-col cols="12" sm="auto" class="mx-auto" v-if="BottonLeftMenuList.length">
                <template v-for="(section, index) in BottonLeftMenuList">
                  <!-- <section class="pb-4"> -->
                  <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                    :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                    :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="section"
                    :type_menu="section.has_children ? 'Initial_Menu' : 'Item_List_Menu_LEFTSide'" @to_close_MenuDialog="to_close_MenuDialog" />
                  <!-- </section> -->
                </template>
              </v-col>
              <v-col v-for="(section, index) in BottonRightMenuList" :key="index" cols="12" sm="auto" class="mx-auto">
                <SideBarMenu :is_board_page="is_board_page" :is__adani_page="is__adani_page"
                  :is__gmr_page="is__gmr_page" :is__vardhman_page="is__vardhman_page" :is__parle_page="is__parle_page"
                  :is__granules_page="is__granules_page" :is__emami_page="is__emami_page" :ItemObj="section"
                  :type_menu="section.has_children ? 'Initial_Menu' : 'Item_List_Menu_LEFTSide'" @to_close_MenuDialog="to_close_MenuDialog" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </section>
    </section>
  </div>
</template>

<script>
import SideBarMenu from "@/components/Menu/SideBarMenu.vue";
import _STARR_MENU_ from "@/components/Menu/STARR_Menu.js";
import _Board_MENU_ from "@/components/Menu/BoardPage_Menu.js";
import _Family_MENU_ from "@/components/Menu/FamilyMenu.js";

export default {
  name: "CardMenuList",
  components: {
    SideBarMenu,
  },
  props: {
    is_board_page: {
      type: Boolean,
      default: false,
    },
    is__adani_page: {
      type: Boolean,
      default: false,
    },
    is__gmr_page: {
      type: Boolean,
      default: false,
    },

    is__vardhman_page: {
      type: Boolean,
      default: false,
    },

    is__parle_page: {
      type: Boolean,
      default: false,
    },

    is__granules_page: {
      type: Boolean,
      default: false,
    },

    is__emami_page: {
      type: Boolean,
      default: false,
    },
    is__family_page: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.menu_load();
  },
  data() {
    return {
      TopMenuList: [],
      BottonLeftMenuList: [],
      BottonRightMenuList: [],
    };
  },
  watch: {
    '$route.path'(newPath) {
      // console.log(newPath, 'newPath');
      this.$nextTick(() => {
        this.menu_load();
      });

    },
    is__family_page(newVal) {
      console.log('CardMenuList: is__family_page changed to:', newVal);
      this.$nextTick(() => {
        this.menu_load();
      });
    }
  },
  methods: {
    to_close_MenuDialog() {
      this.$emit("to_close_MenuDialog");
    },
    menu_load() {
      // Check if logged in via FamilyBook
      const isFamilyBook = localStorage.getItem("is_family_book") === "true";

      console.log('CardMenuList menu_load:', {
        isFamilyBook,
        is__family_page: this.is__family_page,
        is_board_page: this.is_board_page,
        route_path: this.$route.path
      });

      const isPartner = localStorage.getItem("domain") === "partner";

      let TempMenuObj;
      if (isPartner) {
        console.log('CardMenuList: Loading Partner Menu (STARR subset)');
        TempMenuObj = _STARR_MENU_;
      } else if (isFamilyBook || this.is__family_page) {
        console.log('CardMenuList: Loading Family Menu');
        TempMenuObj = _Family_MENU_;
      } else if (this.is_board_page) {
        console.log('CardMenuList: Loading Board Menu');
        TempMenuObj = _Board_MENU_;
      } else {
        console.log('CardMenuList: Loading STARR Menu');
        TempMenuObj = _STARR_MENU_;
      }

      console.log('CardMenuList TempMenuObj:', TempMenuObj);
      const deepClone = obj => JSON.parse(JSON.stringify(obj));
      const product_list = (localStorage.getItem("tectalik_product_list") || "").split(",").filter(Boolean);
      const filterHidden = (items) => items
        .filter(item => {
          if (item.hide) return false;
          if (item.product_gate && item.product_code && item.product_code.length) {
            return item.product_code.some(p => product_list.includes(p));
          }
          return true;
        })
        .map(item => {
          if (item.children) item.children = filterHidden(item.children);
          return item;
        });
      const cloneAndFilter = (list) => filterHidden(deepClone(list || []));
      this.TopMenuList = this.markSelectedByPath(cloneAndFilter(TempMenuObj.TopMenuList), this.$route.path);
      this.BottonLeftMenuList = this.markSelectedByPath(cloneAndFilter(TempMenuObj.BottonLeftMenuList), this.$route.path);
      this.BottonRightMenuList = this.markSelectedByPath(cloneAndFilter(TempMenuObj.BottonRightMenuList), this.$route.path);
      console.log('CardMenuList: Menus loaded - Top:', this.TopMenuList.length, 'BottomLeft:', this.BottonLeftMenuList.length, 'BottomRight:', this.BottonRightMenuList.length);
    },
    markSelectedByPath(data, path) {
      function traverse(node) {
        let matched = false;

        if (node.children && node.children.length > 0) {
          node.children = node.children.map(child => {
            const result = traverse(child);
            if (result.matched) matched = true;
            return result.node;
          });

          node.is___select = matched ? true : null;
        } else {
          if (node.to === path) {
            node.is___select = true;
            matched = true;
          } else {
            node.is___select = null;
          }
        }

        return { node, matched };
      }

      return data.map(item => traverse(item).node);
    },
  },
};
</script>